<template>
<div>
  <div class="row" style="height: 60px"></div>
  <div class="row titleRow">
    <div class="col">
      <h2>{{$t('howManyTimes.subtitle')+$store.state.form.resultJson.userInfos.firstname+" "+$store.state.form.resultJson.userInfos.lastname}}</h2>
      <h1>{{$t('howManyTimes.title')}}</h1>
    </div>
  </div>
  <div class="row listOfButtons">
    <div class="col">
      <button :class="'btn btn-secondary targetButton ' + ((frequency == '1TimeAWeek') ? 'bg-color' : '')" @click="frequency='1TimeAWeek'">{{$t('howManyTimes.1TimeAWeek')}}</button>
    </div>
    <div class="col">
      <button :class="'btn btn-secondary targetButton ' + ((frequency == '23TimesAWeek') ? 'bg-color' : '')" @click="frequency='23TimesAWeek'">{{$t('howManyTimes.23TimesAWeek')}}</button>
    </div>
    <div class="col">
      <button :class="'btn btn-secondary targetButton ' + ((frequency == 'more3TimesAWeek') ? 'bg-color' : '')" @click="frequency='more3TimesAWeek'">{{$t('howManyTimes.more3TimesAWeek')}}</button>
    </div>
  </div>
    <div class="row">
      <div class="col">
        <h1>{{$t('howManyTimes.rateOf')}}</h1>
      </div>
    </div>
    <div class="row listOfButtons separatedRow">
      <div class="col">
        <button :class="'btn btn-secondary targetButton ' + ((rateTime == '30') ? 'bg-color' : '')" @click="rateTime='30'">30 {{$t('howManyTimes.minutes')}}</button>
      </div>
      <div class="col">
        <button :class="'btn btn-secondary targetButton ' + ((rateTime == '45') ? 'bg-color' : '')" @click="rateTime='45'">45 {{$t('howManyTimes.minutes')}}</button>
      </div>
      <div class="col">
        <button :class="'btn btn-secondary targetButton ' + ((rateTime == '60') ? 'bg-color' : '')" @click="rateTime='60'">60 {{$t('howManyTimes.minutes')}}</button>
      </div>
      <div class="col">
        <button :class="'btn btn-secondary targetButton ' + ((rateTime == '90') ? 'bg-color' : '')" @click="rateTime='90'">90 {{$t('howManyTimes.minutes')}}</button>
      </div>
      <div class="col">
        <button :class="'btn btn-secondary targetButton ' + ((rateTime == 'allTime') ? 'bg-color' : '')" @click="rateTime='allTime'">{{$t('howManyTimes.allTime')}}</button>
      </div>
    </div>
  <div class="row">
    <div class="col overFooter">
      <button type="submit" :class="'btn btn-primary alignRight ' + ((frequency !== '' && rateTime !== '') ? 'bg-color' : '')" @click="saveData()">{{$t('general.next')}}</button>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'how-many-times',
  data () {
    return {
      frequency: '',
      rateTime: ''
    };
  },
  updated: function () {
    // Vérifie si les champs obligatoires ont bien été remplis
    this.$store.dispatch('form/FORM_AUTHORIZENEXTSTEP', {layout: 'HowManyTimes', isAuthorized: this.frequency !== '' && this.rateTime !== '', data: this.dataToSave});
  },
  methods: {
    saveData: function () {
      if (this.frequency !== '' && this.rateTime !== '') {
        this.$store.dispatch('form/FORM_NEXTLAYOUT', this.dataToSave);
      }
    }
  },
  computed: {
    dataToSave: function () {
      return {
        howManyTimes: {
          frequency: this.frequency,
          rateTime: this.rateTime
        }
      };
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/HowManyTimes.vue